import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { setMessage } from "../message/Message";
import FileService from "../../../services/FileService";

const initialState = {
  OwnFiles: [],
  loading: false,
  error: null,
  deleteFile:[],
  deleteFileLoad:false,
  shareFileByUser:[],
  shareFileByUserLoad:false,
  shareFileByGruop:[],
  shareFileByGruopLoad:false,
  
};

export const myFiles = createAsyncThunk(
  "myFiles/myFiles",
  async ({ id, name }, thunkAPI) => {

    try {
      const response = await FileService.myFiles({ id, name });
      return response.data.data;
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.error) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);


export const deleteFiles = createAsyncThunk(
  "myFiles/deleteFiles",
  async (fileId, thunkAPI) => {

    try {
      const response = await FileService.deleteFiles(fileId);
      return response.data.data;
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.error) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);


export const shareFileByUser = createAsyncThunk(
  "myFiles/shareFileByUser",
  async ({fileId,selectedRecipients,id}, thunkAPI) => {
    console.log("shareFileByUser slice",fileId,selectedRecipients,id)
    try {
      const response = await FileService.shareFileByUser(fileId,selectedRecipients,id);
      return response.data;
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.error) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);


export const shareFileByGruop = createAsyncThunk(
  "myFiles/shareFileByGruop",
  async ({fileId,selectedGruop,id}, thunkAPI) => {
    console.log("shareFileByGruop slice",fileId,selectedGruop,id)
    try {
      const response = await FileService.shareFileByGruop(fileId,selectedGruop,id);
      return response.data;
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.error) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);


const FileSlice = createSlice({
  name: "myFiles",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(myFiles.pending, (state) => {
        state.loading = true;
      })
      .addCase(myFiles.fulfilled, (state, action) => {
        state.OwnFiles = action.payload;
        state.loading = false;
      })
      .addCase(myFiles.rejected, (state) => {
        state.OwnFiles = [];
        state.loading = false;
      })


      .addCase(deleteFiles.pending, (state) => {
        state.deleteFileLoad = true;
      })
      .addCase(deleteFiles.fulfilled, (state, action) => {
        state.deleteFile = action.payload;
        state.deleteFileLoad = false;
      })
      .addCase(deleteFiles.rejected, (state) => {
        state.deleteFile = [];
        state.deleteFileLoad = false;
      })

      

      .addCase(shareFileByUser.pending, (state) => {
        state.shareFileByUserLoad = true;
      })
      .addCase(shareFileByUser.fulfilled, (state, action) => {
        state.shareFileByUser = action.payload;
        state.shareFileByUserLoad = false;
      })
      .addCase(shareFileByUser.rejected, (state) => {
        state.shareFileByUser = [];
        state.shareFileByUserLoad = false;
      })



      .addCase(shareFileByGruop.pending, (state) => {
        state.shareFileByGruopLoad = true;
      })
      .addCase(shareFileByGruop.fulfilled, (state, action) => {
        state.shareFileByGruop = action.payload;
        state.shareFileByGruopLoad = false;
      })
      .addCase(shareFileByGruop.rejected, (state) => {
        state.shareFileByGruop = [];
        state.shareFileByGruopLoad = false;
      })
  },
});

const { reducer } = FileSlice;
export default reducer;
